/* Source: /home/runner/work/jaseci-blogs/jaseci-blogs/pages/[...notFound].jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { Link } from "@jac/runtime";
import { useEffect } from "@jac/runtime";
function Page() {
  useEffect(() => {
    document.title = "Not found \u00b7 Jaseci Blogs";
  }, []);
  return __jacJsx("section", {"className": "container narrow", "style": {"padding": "6rem 0"}}, [__jacJsx("p", {"className": "eyebrow"}, ["404"]), __jacJsx("h1", {"className": "display"}, ["Lost your way?"]), __jacJsx("p", {"className": "post-deck"}, ["The page you're looking for doesn't exist. It may have been retired, renamed, or never published."]), __jacJsx("p", {"style": {"marginTop": "2rem"}}, [__jacJsx(Link, {"className": "cta-pill", "to": "/blog"}, ["← Back to latest"])])]);
}
const page = Page;
/*jac:refresh-boundary*/;
export {page};
//# sourceMappingURL=[...notFound].js.map
